import { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { groupServices } from "../../APIServices/PasswordManagement/groupServices";
import { encryptGroupKey, generateNewKey } from "../../APIHelpers/utils";
import { useApp } from "../../APIHelpers/AppContext";

const AddGroup = ({ Show, Hide, Title, setUpdator, isDark, auth }) => {
  const { getVaultKey } = useApp();
  const [groupName, setGroupName] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewGroup = async () => {
    let userData = {}
    setLoader(true)
    let groupKey = await generateNewKey()
    let { encryptedGroupKey, groupKeyIV } = await encryptGroupKey(groupKey, getVaultKey())
    userData.groupName = groupName
    userData.groupKey = encryptedGroupKey
    userData.groupKeyIV = groupKeyIV
    let data = await groupServices.addNewGroup(auth, userData)
    if (data?.statusCode === 200) {
      setGroupName("")
      setUpdator(`groupList_${Math.floor(10000 + Math.random() * 90000)}`);
      Hide()
    }
    setLoader(false)
  }

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Group Name{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Group Name"
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}>
        <Button
          variant="outline-primary"
          disabled={!groupName || loader}
          onClick={addNewGroup}
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
        >
          {Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddGroup;
